import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import humanRemainsImg from "../../../../assets/imgs/services/nationals/human-remains.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function HumanRemains() {
  const [tHumanRemains] = useTranslation("humanRemainsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idHumanRemains = "6a1613dd-4bc4-4d29-b519-24eb5e068063";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[7]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[7]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHumanRemains}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("restosHumanos.title")}</title>
        <meta
          name="description"
          content={tSMetaData("restosHumanos.description")}
        />
      </Helmet>
      <ImageHeader
        section={tHumanRemains("header.section")}
        title={tHumanRemains("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHumanRemains("description.content"))
        }
        quoteBtn={tHumanRemains("header.quote-btn")}
        quoteProductID="btnQuoteRemains"
        contactSales={tHumanRemains("header.contact-sales")}
        contactProductID="btnContactRemains"
        imgBackground={humanRemainsImg}
      />
      <Accordion
        title={tHumanRemains("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tHumanRemains("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHumanRemains("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHumanRemains("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHumanRemains("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tHumanRemains("accordion-3.content"))
        }
      />
    </>
  );
}

export default HumanRemains;
